export default __webpack_public_path__ + "static/media/tractebelsolo.b1d66c66.png";